export default {
  host: '/api'
}
